import React from 'react';
//material
import {Card, CardContent, withStyles, CardHeader, Table, TableBody, TableRow, TableCell, Button} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './my-meetings-widget-styles';
//lib
import Moment from 'moment';
import { withRouter } from 'react-router-dom';

const MyMeetingsWidgetView = (props) => {
  const {classes, isLoading, myMeetings, history} = props;
  const meetings = [...myMeetings].splice(0, 5);

  const navigateToMeeting = (eventId) =>
    history.push('/meeting/' + eventId);

  const navigateToMyMeetings = () =>
    history.push('/my-meetings')

  return (
    <Card className={classes.card}>
      {
        isLoading ?
          <Skeleton width={'50%'} className={classes.titleSkeleton}/> :
          <CardHeader title={'My Upcoming Meetings'} classes={{title: classes.title}} className={classes.titleContainer}/>
      }

      <CardContent className={classes.cardContent}>
        {
          !isLoading && meetings.length > 0 &&
            <Table>
              <TableBody>
                {
                  meetings.map((e, i) =>
                  <TableRow key={i} hover onClick={() => navigateToMeeting(e.eventId)} className={classes.row}>
                    <TableCell className={classes.cell}>{Moment(new Date(e.eventDate)).format('Do MMMM YYYY')}</TableCell>
                    <TableCell className={classes.cell}>{e.eventName}</TableCell>
                  </TableRow>)
                }
              </TableBody>
            </Table>
        }

        {
          isLoading &&
            <>
              <Skeleton variant={'rect'} height={30} className={classes.rowSkeleton}/>
              <Skeleton variant={'rect'} height={30} className={classes.rowSkeleton}/>
              <Skeleton variant={'rect'} height={30} className={classes.rowSkeleton}/>
              <Skeleton variant={'rect'} height={30} className={classes.rowSkeleton}/>
              <Skeleton variant={'rect'} height={30} className={classes.rowSkeleton}/>
            </>
        }

        {
          meetings.length === 0 &&
            <div className={classes.noMeetings}>
              No Upcoming Meetings
            </div>
        }
      </CardContent>

      {
        !isLoading && myMeetings.length > 0 &&
        <div className={classes.buttonContainer}>
          <Button
            color={'primary'}
            size={'small'}
            aria-label={'small'}
            variant={'contained'}
            onClick={navigateToMyMeetings}>
            View My Meetings
          </Button>
        </div>
      }
    </Card>
  );
};

export default withRouter(withStyles(styles) (MyMeetingsWidgetView));
